import React from 'react';

const SuggestedActions = ({ actions, onActionClick }) => {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {actions.map((action, index) => (
        <button
          key={index}
          className="px-3 py-1.5 bg-[#e9f0ff] text-primary rounded-full text-xs font-medium hover:bg-[#d1e0ff] transition-colors"
          onClick={() => onActionClick(action)}
        >
          {action.text}
        </button>
      ))}
    </div>
  );
};

export default SuggestedActions;